import { closeSliderCart } from '../slider-cart';
// import loadCachedColorFamilies from '../../components/data-caching/loadCachedColorFamilies';

let subnav_timeout = null;

const closeSubnav = (/* log_call */) => {
  // console.log('closeSubnav', log_call);
  if (!$('[data-parent="search"]').hasClass('keep-opened') && !$('[data-parent="account"]').hasClass('keep-opened')) {
    $('.nav__level-2').removeClass('opened');
    $('.main-nav--desktop .nav__level-1 li a').attr('aria-expanded', false);

    // resetSearchResults();
  }

  $('.main-nav--desktop .nav__level-1 li').removeClass('hover');
  clearTimeout(subnav_timeout);
};

const openSubnav = ($item) => {
  // console.log('Open sub nav');
  const handle = $item.data('handle');

  $('[data-no-children]').removeClass('hover');

  // We don't want to close the current option
  _.each($('.nav__level-2'), (level_2) => {
    if ($(level_2).data('parent') !== handle) {
      $(level_2).removeClass('opened');
      $(level_2).closest('li').removeClass('hover');
      $(level_2).closest('li').find('[data-desktop-nav-a]').attr('aria-expanded', false);
    }
  });

  $item.addClass('hover');
  $item.find('a').attr('aria-expanded', true);

  // if ($item.data('handle') === 'account') {
  // $item.find('a').first().attr('aria-expanded', true);
  // }

  if (handle === 'search') {
    // $('[data-search-nav]').trigger('click');
    return;
  }

  _.each($('.nav__level-2'), (lv2) => {
    if (typeof handle !== 'undefined' && $(lv2).data('parent') === handle) {
      $(lv2).addClass('opened');

      closeSliderCart();
    }
  });
};

// Only works for search and account right now
const keepOpened = (keep) => {
  let close = 'search';
  if (keep === 'search') {
    close = 'account';
  }
  // console.log(keep, close);

  if ($(`[data-parent="${close}"]`).hasClass('keep-opened')) {
    $(`[data-parent="${close}"]`).removeClass('keep-opened');
    closeSubnav('keepOpened a');
    $('[data-handle="account"] a').attr('aria-expanded', false);
  }

  /* 
  Code for AB testing tool:
    Experiment A: no changes, a is used by default
    Experiment B: document.getElementById('accountNav').parentElement.dataset.abTesting = 'b';
  */
 /*
  if (keep === 'account') {
    if ($('#accountNav').parent().attr('data-ab-testing') === 'b' && typeof window.theme.customer.id === 'undefined') {
      // Open as modal
      $('#main-signin-modal').modal({
        fadeDuration: 250,
        fadeDelay: 0.80,
      });

      $('#main-signin-modal').off($.modal.OPEN);
      $('#main-signin-modal').on($.modal.OPEN, () => {  
        // [ADA]
        $('#main-signin-modal .close-modal').attr('role', 'button');
        $('#main-signin-modal .close-modal').trigger('focus');
      });
  
      $('#main-signin-modal').off($.modal.CLOSE);
      $('#main-signin-modal').on($.modal.CLOSE, () => {
        // [ADA] We don't want to get the focus back at the beginning of the page
        $('[data-cart-nav]').trigger('focus');
      });

      return;
    }
  }
  */

  $(`[data-parent="${keep}"]`).toggleClass('keep-opened');

  if ($(`[data-parent="${keep}"]`).hasClass('keep-opened')) {
    if (keep === 'account') {
      // Closes the search overlay
      $('[data-overlay-search-close]').trigger('click');

      // Open as subnav
      $(`[data-parent="${keep}"]`).addClass('opened');
      $(`[data-handle="${keep}"] a`).attr('aria-expanded', true);

      $('#accountNav').removeClass('visually-hidden');
      $('#accountNav').attr('tabindex', 0);
    }
  } else {
    closeSubnav('keepOpened b');
    $(`[data-handle="${keep}"] a`).attr('aria-expanded', false);

    if (keep === 'account') {
      $('#accountNav').addClass('visually-hidden');
      $('#accountNav').attr('tabindex', -1);
    }
  }
};

const initDesktopNav = () => {
  const mouse_pos = {};

  $(document).on('click', '[data-search-nav],[data-mobile-nav-search]', () => {
    // Only init once when we really need it needs to load some data. We don't want to slow down the initial page load
    // if (!window.theme.search.init) {
    //   await initOverlaySearch();
    // }

    // Load the color families cached by the colors app
    // if (!window.theme.collections.color_families_all.length) {
    //   window.theme.collections.color_families_all = loadCachedColorFamilies(window.theme.collections.color_families_file);
    // }

    // Close the account dropdown
    $('[data-parent="account"]').removeClass('keep-opened');
    $('[data-handle="account"] a').attr('aria-expanded', false);
    closeSubnav();

    // keepOpened('search');
    closeSliderCart();
    $('[data-overlay-search]').addClass('opened');
    $('body').addClass('has-overlay-search');
    // $('[data-overlay-search-results]').css('margin-top', $('[data-overlay-search-form]').outerHeight(true));
    window.setTimeout(() => {
      $('[data-main-nav]').hide();
    }, 250);
    
    $(window).trigger('scroll');

    // [ADA]
    $('#overlaySearchInput').trigger('focus');
  });

  // We're now using a direct link for logged out state
  $(document).on('click', '.logged-in [data-account-nav] [data-desktop-nav-a]', () => {
    keepOpened('account');
  });

  $(document).on('click', '[data-account-close]', () => {
    $('[data-parent="account"]').removeClass('opened').removeClass('keep-opened');
    $('[data-handle="account"] a').attr('aria-expanded', false);
  });

  // Keep track of mouse coordinates
  $(document).on('mousemove', (e) => {
    mouse_pos.x = e.pageX;
    mouse_pos.y = e.pageY;
  });

  // Tablet - Prevent following the level 1 link
  $(document).on('touchend', '.main-nav--desktop .nav__level-1 .level-1-option', (e) => {
    const $item = $(e.currentTarget);
    $item.find('[data-desktop-nav-a]').attr('href', 'javascript:void(0);');
    $item.trigger('mouseleave');
  });

  $(document).on('mouseenter', '.main-nav--desktop .nav__level-1 .level-1-option', (e) => {
    if ($('[data-parent="search"]').hasClass('keep-opened') || $('[data-parent="account"]').hasClass('keep-opened')) {
      return;
    }

    const $item = $(e.currentTarget);
    const position = $item.offset();
    const height = $item.height();
    const width = $item.width();
    const maxX = width + position.left;
    const maxY = height + position.top;

    // It's annoying to hover the nav and open it by mistake, now it takes a few ms before opening it
    subnav_timeout = setTimeout(() => {
      // console.log('Current mouse position: ' + mouse_pos.x + ',' + mouse_pos.y);
      if (mouse_pos.x >= position.left && mouse_pos.x < maxX && mouse_pos.y > position.top && mouse_pos.y < maxY) {
        openSubnav($item);
      }
    }, window.theme.nav.delayed);
  });

  $(document).on('mouseleave', '.main-nav--desktop .nav__level-1 li', (e) => {
    // There's an annoying margin-top -5px
    if (e.pageY >= $(document).scrollTop() + $('.main-nav').height() - 5) {
      // User hovers the subnav
      // console.log('User hovers the subnav');
    } else {
      closeSubnav(`mouseleave nav__level-1 li ${e.pageY} < ${$(document).scrollTop() + $('.main-nav').height() - 5}`);

      // const $item = $(e.currentTarget);
      // const handle = $item.data('handle');

      // if (handle === 'account') {
      //   $('.nav__level-2[data-parent="account"]').css('top', 0);
      // }
    }
  });

  $(document).on('mouseleave', '.nav__level-2.opened', () => {
    // if (e.pageY >= $(document).scrollTop() + $item.position().top + $item.outerHeight()) {
    closeSubnav('mouseleave .nav__level-2.opened');
    // }
  });

  // When we don't have a full width subnav
  $(document).on('mouseleave', '.nav__level-2.opened .mega__container', () => {
    closeSubnav('mouseleave .nav__level-2.opened .mega__container');
  });
  // $(document).on('focusout', '.nav__level-2.opened', (e) => {
  //   const $item = $(e.currentTarget);
  //   $item.trigger('mouseleave');
  // });

  // Leave the main nav
  $(document).on('mouseleave', '.main-nav', (e) => {
    // const $item = $(e.currentTarget);
    // From left/right sides
    // if (e.pageX < $item.position().left || e.pageX > $item.position().left + $item.outerWidth()) {
    //   closeSubnav('mouseleave .main-nav');
    // }
    closeSubnav('mouseleave .main-nav');
  });
  // $(document).on('focusout', '.main-nav', (e) => {
  //   const $item = $(e.currentTarget);
  //   $item.trigger('mouseleave');
  // });

  window.addEventListener('mouseleave', (e) => {
    if (e.pageX <= 0 || e.pageX >= $(window).width()) {
      closeSubnav('window mouseleave');
    }
  });
};

export {
  initDesktopNav,
  openSubnav,
  closeSubnav,
};
